
import Vue from "vue"

export default Vue.extend({
  props: {
    colored: { type: Boolean, default: false },
  },
})
